"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runEvent = runEvent;
const applyEvent_1 = require("../../core/dist/applyEvent");
async function runEvent(weaveSlug, event, deps) {
    const weave = await deps.loadWeave(deps.loomRoot, weaveSlug);
    const { weave: updatedWeave, changed } = (0, applyEvent_1.applyEvent)(weave, event);
    await deps.saveDocs(deps.loomRoot, updatedWeave, changed);
    return updatedWeave;
}
